import React from "react";
import { Button, Row, Col, Card, Tooltip, } from "antd";
import { ArrowLeftOutlined, } from "@ant-design/icons";



const ConsultHeaderCard = ({ longTitle, shortTitle, subTitle, size, backgroundColor, className, onBack }) => {

    return (
        <Row gutter={24}>
            <Col xl={24} lg={0} md={0} sm={0} xs={0}>
                <Card style={{ borderRadius: "0", backgroundColor: backgroundColor ? backgroundColor : "#ffffff" }} className={ className ? className : null }>
                    <Row gutter={24} align="middle">
                        <Col xl={4} lg={4} sm={0} md={0} xs={0}></Col>
                        <Col xl={16} lg={16} sm={0} md={0} xs={0} className="text-center">
                            <h3 style={{ padding: "0", margin: "0", fontWeight: "400" }}>
                                {longTitle}
                            </h3>
                            <h4 style={{ padding: "0", margin: "0", fontWeight: "400" }}>
                                {subTitle}
                            </h4>
                        </Col>
                        <Col xl={4} lg={4} sm={0} md={0} xs={0} className="text-right">
                            <Button
                                block
                                ghost
                                type="primary"
                                onClick={onBack}
                                style={{ height: '37px' }}
                                size={size ? size : null}
                                icon={<ArrowLeftOutlined />}
                            >
                                Kthehu
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col xl={0} lg={24} md={24} sm={24} xs={24}>
                <Card style={{ borderRadius: "0", backgroundColor: backgroundColor ? backgroundColor : "#ffffff" }}>
                    <Row gutter={24} align="middle">
                        <Col xl={3} lg={3} sm={3} md={3} xs={3}></Col>
                        <Col xl={18} lg={18} sm={18} md={18} xs={18} className="text-center">
                            <h5 style={{ padding: "0", margin: "0", fontWeight: "400" }}>
                                {shortTitle}
                            </h5>
                        </Col>
                        <Col xl={3} lg={3} sm={3} md={3} xs={3} className="text-right">
                            <Tooltip title="Kthehu">
                                <Button
                                    block
                                    size={size ? size : null}
                                    type="secondary"
                                    onClick={onBack}
                                    icon={<ArrowLeftOutlined />}
                                />
                            </Tooltip>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};

export default ConsultHeaderCard;